module.exports = __webpack_public_path__ + "img/34.cd7e724c.jpg";